import React from 'react';
import Head from 'expo-router/head';
import { StaticContentScreen } from '@components/common';

const privacySections = [
  {
    title: 'Data We Collect',
    body: 'Redi collects information you provide directly: your name, email address, profile photo, property claims, posts (including photos and captions), and checklist progress. We also collect your approximate location when you use location-based features.',
  },
  {
    title: 'How We Use Your Data',
    body: 'We use your data to provide the Redi service: displaying your posts and property information to your community, tracking checklist compliance, and enabling communication between community members and stakeholders.',
  },
  {
    title: 'Data Storage',
    body: 'Your data is stored securely using Google Firebase infrastructure. Photos are stored in Firebase Storage and account data in Firebase Firestore. All data is encrypted in transit.',
  },
  {
    title: 'Data Sharing',
    body: 'We do not sell your personal data. Your posts and property information are visible to other Redi users. Aggregated compliance data may be shared with insurance partners in your community.',
  },
  {
    title: 'Your Rights',
    body: 'You can update your profile information at any time through the Account screen. You can delete your account and all associated data through Settings. You can contact us to request a copy of your data.',
  },
  {
    title: 'Contact',
    body: 'For privacy-related questions or requests, contact us at support@weareredi.net.',
  },
];

export default function PrivacyScreen() {
  return (
    <>
      <Head>
        <title>Privacy Policy - Redi</title>
      </Head>
      <StaticContentScreen
        title="Privacy Policy"
        sections={privacySections}
        footerText="Last updated: April 2026"
      />
    </>
  );
}
